// NOTE: this file was originally generated by Lovable and shipped with a
// "do not edit" header. It is now hand-maintained on purpose: the connection
// must vary per environment, which a generated literal cannot do.
// Regenerated only once since the initial Lovable import, so regeneration is
// not an active risk.
// scripts/check-no-hardcoded-supabase-ref.mjs guards against a regression.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { resolveSupabaseEnv } from './env';

const { url, publishableKey } = resolveSupabaseEnv(import.meta.env);

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(url, publishableKey, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
